import { useCurrentWorkspace } from '@/context/current-workspace';
import { useSampleWorkspace } from '@/features/workspaces/sample-workspace';
import * as styles from './index.css';

/**
 * The stripe shown at the top of the page. The color is configured by the user
 */
export function WorkspaceStripe() {
  const workspace = useCurrentWorkspace();
  const { isSampleWorkspace } = useSampleWorkspace();

  // Don't show stripe for sample workspace
  if (isSampleWorkspace(workspace?.id)) {
    return null;
  }

  return <div className={styles.workspaceStripe} />;
}
